import { useEffect, useState } from "react";
import { fetchData, fetchImage } from "../../utils/fetch";
import { Flex } from "antd";

export default function Partners() {
  const [partners, setPartners] = useState([]);
  const [partnerImages, setPartnerImages] = useState({});

  useEffect(() => {
    async function loadPartners() {
      try {
        const partnersData = await fetchData(`front/partners`);
        setPartners(partnersData);
      } catch (error) {
        console.log("Could not fetch partners: " + error);
      }
    }
    loadPartners();
  }, []);

  useEffect(() => {
    async function loadPartnerImages() {
      const newPartnerImages = {};
      try {
        for (const partner of partners) {
          const imageResponse = await fetchImage(`front/image/partners/${partner.id}/${partner.image}`);
          if (imageResponse.ok) {
            const imageBlob = await imageResponse.blob();
            const imgUrl = URL.createObjectURL(imageBlob);
            newPartnerImages[partner.id] = imgUrl;
          } else {
            newPartnerImages[partner.id] = null;
          }
        }
        setPartnerImages(newPartnerImages);
      } catch (error) {
        console.log("Failed to load images: " + error);
      }
    }
    if (partners.length > 0) {
      loadPartnerImages();
    }
  }, [partners]);

  const imgStyle = {
    height: "80px",
    objectFit: "contain"
  }

  // === KEYFRAMES IN JS ===
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes scroll {
        0% { transform: translateX(0%); }
        100% { transform: translateX(-50%); }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <>
      <h1 style={{ marginLeft: "10px", textAlign: "center" }}>Dôverujú nám</h1>
      <Flex wrap align="center" justify="space-evenly">
        {
          partners.map((partner) => (
            partnerImages[partner.id] && <img style={imgStyle} src={partnerImages[partner.id]} alt={partner.name}></img>
          ))
        }
      </Flex>
    </>

  );
}
